export const ASSESSMENT_FIELDS = {
  NAME: "category",
  DESCRIPTION: "description",
  STANDARD: "standard",
  MAX_SCORE: "maxScore",
  WEIGHT: "weight",
  ACTION: "action",
  SELF_RATE: 'selfRate',
  OFFICE_DIRECTOR_RATE: 'officeDirectorRate',
  LEADER_RATE: 'leaderRate',
  SUPERVISOR_RATE: 'supervisorRate',
  HR_OFFICE_RATE: 'hrOfficeRate',
  AI_RATE: 'aiRate'
};

export const ASSESSMENT_FIELD_LABELS = {
  [ASSESSMENT_FIELDS.NAME]: "关键指标",
  [ASSESSMENT_FIELDS.DESCRIPTION]: "本月工作目标/计划",
  [ASSESSMENT_FIELDS.STANDARD]: "本月完成进度和需达到的标准",
  [ASSESSMENT_FIELDS.MAX_SCORE]: "最高分",
  [ASSESSMENT_FIELDS.WEIGHT]: "单项分值",
  [ASSESSMENT_FIELDS.ACTION]: "操作",
};

export const SCORE_RATE_LABELS = {
  [ASSESSMENT_FIELDS.SELF_RATE]: "本月实际完成情况",
  [ASSESSMENT_FIELDS.AI_RATE]: "AI评分",
  [ASSESSMENT_FIELDS.OFFICE_DIRECTOR_RATE]: "办事处主任评",
  [ASSESSMENT_FIELDS.LEADER_RATE]: "部长评",
  [ASSESSMENT_FIELDS.SUPERVISOR_RATE]: "总监评",
  [ASSESSMENT_FIELDS.HR_OFFICE_RATE]: "考核办"
};